
<div v-if="site" class="site-data-panel v-flex">
    <p-site-tzb-calculation
        v-if     = "tzb"
        v-model  = "showTzbCalculation"
        :unit-id = "site.id"
        :tzb     = "tzb"
    />

    <t-site-menu
        :key     = "refreshMenu"
        :edit    = "edit"
        :history = "tab === 2"
        :history-editable="tab === 2 && isEscalator"
        :reports = "tab === 2"
        :condition="tab === 2 && site.customer.extendedConditions && this.isElevator"
        :download= "(site.liftmanagement && tab === 8) || (!site.liftmanagement && tab === 7)"
        v-if     = "menuTabs.includes (realTab)"
        @readonly= "onReadonly"
        @save    = "onSave"
        @close   = "onClose"
        @refresh = "onRefresh"
        @history = "onHistory"
        @reports = "onReports"
        @extended-conditions = "onExtendedConditions"
        ref      = "menu"
    />

    <div
        v-if = "!menuTabs.includes (realTab)"
        style="margin-left: 75px;"
    >
    </div>

    <v-tabs
        v-model      = "tab"
        class        = "folder-tabs ml-0 pr-0 mr-0"
        active-class = "folder-tab-active primary"
        height       = "40"
        style="max-width: calc(100% - 75px);"
        show-arrows
    >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
            class = "folder-tab"
            :key  = "1"
        >
            <span><v-icon size="20">{{  readonly ? 'mdi-eye-outline' : 'mdi-pen' }}</v-icon></span>
            <span class="pl-2">Anlage</span>
        </v-tab>

        <v-tab
            class = "folder-tab"
            :key  = "2"
        >
            <span><v-icon size="20">{{  readonly ? 'mdi-eye-outline' : 'mdi-pen' }}</v-icon></span>
            <span class="pl-2">Spezifikation</span>
        </v-tab>

        <v-tab
            class = "folder-tab"
            :key  = "3"
        >
            <div class="v-flex">
                <div class="mr-2">
                    TZB
                </div>
                <c-site-tzb-rating
                    v-if="tzb && tzb.rating"
                    class   = "rating-tab"
                    :color  = "tab === 2 ? 'white' : 'primary'"
                    v-model = "tzb.rating"
                />
            </div>
        </v-tab>

        <v-tab
            class = "folder-tab"
            :key  = "4"
        >
            GBU / ESG
        </v-tab>

        <v-tab
            class = "folder-tab"
            :key  = "5"
        >
            Kontakte
        </v-tab>

        <v-tab
            class = "folder-tab"
            :key  = "6"
        >
            Adressen
        </v-tab>

        <v-tab
            class = "folder-tab"
            :key  = "7"
            v-if  = "site.liftmanagement"
        >
            Vertragsdaten
        </v-tab>
        <v-tab
            class = "folder-tab"
            :key  = "8"
        >
            <span><v-icon size="20">{{  readonly ? 'mdi-eye-outline' : 'mdi-pen' }}</v-icon></span>
            <span class="pl-2">Notizen</span>
        </v-tab>

        <v-tab
            class = "folder-tab"
            :key  = "9"
        >
            Bilder
        </v-tab>

        <v-tab
            class = "folder-tab"
            :key  = "10"
        >
            <span><v-icon size="20">{{  readonly ? 'mdi-eye-outline' : 'mdi-pen' }}</v-icon></span>
            <span class="pl-2">Wartungen</span>
        </v-tab>

        <v-tab
            class = "folder-tab"
            :key  = "11"
        >
            ZÜS Prüfungen
        </v-tab>
        <v-tab
            class = "folder-tab"
            :key  = "12"
        >
            Dokumente
        </v-tab>

        <v-tabs-items v-model="tab">
            <v-tab-item :key="1">
                <t-site-core
                    :site     = "site"
                    :readonly = "readonly"
                    ref       = "corePage"
                    @saved    = "onSaved"
                    @customer = "onCustomer"
                />
             </v-tab-item>

            <v-tab-item
                v-if="isElevator || isEscalator"
                :key="2"
            >
                <t-site-specification-elevator
                    v-if      = "isElevator"
                    :site-id  = "site.id"
                    :spec     = "site.specification"
                    :tzb      = "tzb"
                    :readonly = "readonly"
                    ref       = "pageElevator"
                    @type     = "onType"

                />
                <t-site-specification-escalator
                    v-if      = "isEscalator"
                    :site-id  = "site.id"
                    :spec     = "site.specification"
                    :tzb      = "tzb"
                    :readonly = "readonly"
                    ref       = "pageEscalator"
                    @type     = "onType"
                />
            </v-tab-item>

            <v-tab-item
                v-if="!isElevator && !isEscalator"
                :key="2"
            >
                <!-- type only, e.g. doors and gates; the office resolves type conflicts here (HCIT-943) -->
                <t-site-type
                    :site     = "site"
                    :readonly = "readonly"
                    @type     = "onType"
                />
            </v-tab-item>

            <v-tab-item :key="3">
                <t-site-tzb-elevator
                    v-if  = "isElevator"
                    :site = "site"
                    :readonly = "readonly"
                    ref   = "pageTzbElevator"
                />
                <t-site-tzb-escalator
                    v-if      = "isEscalator"
                    :site     = "site"
                    :readonly = "readonly"
                    ref       = "pageTzbEscalator"
                    @saved    = "onTzbSaved"
                />
            </v-tab-item>

            <!--
            <v-tab-item :key="3" v-if="!site.tzb">
                <div class="missing-data">
                    Kein TZB vorhanden
                </div>
            </v-tab-item>
            -->

            <v-tab-item :key="4">
                <c-audits
                    :unit = "site"
                    ref   = "pageAudit"
                />
            </v-tab-item>

             <v-tab-item
                :key="5"
            >
                 <v-card flat>
                     <t-site-contacts
                         :site = "site"
                         ref   = "page"
                     />
                 </v-card>
            </v-tab-item>

            <v-tab-item
                :key="6"
            >
                <v-card flat>
                    <t-site-recipients
                        :site = "site"
                        ref   = "page"
                    />
                </v-card>
            </v-tab-item>

            <v-tab-item
                :key="7"
                v-if="site.liftmanagement"
            >
                <v-card flat>
                    <t-site-contracts
                        :site     = "site"
                        ref       = "page"
                    />
                </v-card>
            </v-tab-item>

            <v-tab-item
                :key="8"
            >
                <v-card flat>
                    <t-site-notes
                        :site-id  = "site.id"
                        :notes    = "site.notes"
                        :readonly = "readonly"
                        ref       = "pageNotes"
                    />
                </v-card>
            </v-tab-item>

            <v-tab-item
                :key="9"
            >
                <v-card flat>
                    <img-site-images
                        :site = "site"
                        ref   = "pageImages"
                    />
                </v-card>
            </v-tab-item>

             <v-tab-item
                :key="10"
            >
                <v-card flat>
                    <t-site-maintenance
                        :site     = "site"
                        :readonly = "readonly"
                        ref       = "page"
                    />
                </v-card>
            </v-tab-item>
            <v-tab-item
                :key="11"
            >
                <v-card flat>
                    <t-site-assessment
                        :site     = "site"
                        :readonly = "readonly"
                        ref       = "page"
                    />
                </v-card>
            </v-tab-item>

            <v-tab-item
                :key="12"
            >
                <v-card flat>
                    <t-site-documents
                        :site = "site"
                    />
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-tabs>
</div>
